import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

const mutateAddRejectDoc = async ({
  documentId,
  data,
}: {
  documentId: string;
  data: any;
}) => {
  return await axiosAuth.post(`${PARK_DOCUMENT}/${documentId}/reject`, data);
};

const useAddRejectDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      documentId: string;
      data: any;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddRejectDoc,
    ...queryParams,
  });

export default useAddRejectDocMutation;
